/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 验证token是否有效，如果有效返回OAuth2Authentication对象, 无效则抛出异常
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: oauth2.OAuth2Authentication;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/oauth2/token-validation`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
